"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileFields = exports.getDisplayNameForCategory = void 0;
var TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
var validation_1 = __importDefault(require("./validation"));
var firstNameField = {
    type: 'string',
    key: 'firstName',
    label: 'First Name',
    get placeholder() {
        return this.label;
    },
    isRequired: true,
    get fieldValue() {
        return this.value;
    }
};
var lastNameField = {
    type: 'string',
    key: 'lastName',
    label: 'Last Name',
    get placeholder() {
        return this.label;
    },
    isRequired: true,
    get fieldValue() {
        return this.value;
    }
};
var emailField = {
    type: 'email',
    key: 'email',
    label: 'Email',
    get placeholder() {
        return this.label;
    },
    isRequired: true,
    get fieldValue() {
        return this.value;
    }
};
var dateOfBirthField = {
    type: 'dateOfBirth',
    key: 'dateOfBirth',
    label: 'Date of Birth',
    get placeholder() {
        return this.label;
    },
    isRequired: true,
    minValue: validation_1.default.minDateOfBirth,
    maxValue: validation_1.default.maxDateOfBirth,
    get fieldValue() {
        return !!this.value ? (0, TimeUtil_1.formatDayMonthYear)(this.value) : '';
    }
};
var genderField = {
    type: 'radio',
    key: 'gender',
    label: 'Gender',
    get placeholder() {
        return this.label;
    },
    isRequired: false,
    options: [
        {
            value: 'MALE',
            label: 'Male'
        },
        {
            value: 'FEMALE',
            label: 'Female'
        }
    ],
    get fieldValue() {
        return this.value;
    }
};
var addressField = {
    type: 'address',
    key: 'address',
    label: 'Address',
    get placeholder() {
        return this.label;
    },
    isRequired: true,
    get fieldValue() {
        return this.value !== null ? this.value.toString() : null;
    }
};
var phoneField = {
    type: 'phone',
    key: 'phone',
    label: 'Mobile Number',
    get placeholder() {
        return this.label;
    },
    isRequired: false,
    get fieldValue() {
        return this.value;
    }
};
var getDisplayNameForCategory = function (key, optionStatus) {
    var customOptions = {
        field_numberAlertFrequency: {
            on: 'daily',
            off: 'weekly'
        }
    };
    if (Object.keys(customOptions).includes(key)) {
        return optionStatus ? customOptions[key]['on'] : customOptions[key]['off'];
    }
    else {
        return undefined;
    }
};
exports.getDisplayNameForCategory = getDisplayNameForCategory;
exports.profileFields = [
    firstNameField,
    lastNameField,
    emailField,
    dateOfBirthField,
    genderField,
    addressField,
    phoneField
];
//# sourceMappingURL=profile.js.map